export function getEnv() {
  let env = window?.AN?.sso?.session?.env;
  if (!['local', 'dev', 'qa', 'stg', 'prod'].includes(env)) {
    env = window.location.host.match(/^(dev|qa|stg|).*\.annalect\.com$/)?.[1];
    if (env === '') env = 'prod';
  }
  if (!env) {
    env = 'local';
  }
  return env;
}

export function getSSOEnv() {
  const env = getEnv();
  return env === 'local' ? 'dev' : env;
}

export function csvParse(text, asObjects = true) {
  const convertToObjects = rows =>
    rows
      .slice(1)
      .map(row => Object.fromEntries(rows[0].map((name, i) => [name, row[i]])));

  let prevChar = '';
  let row = [''];
  let colIndex = 0;
  let rowIndex = 0;
  let outsideQuote = true;
  const rows = [row];

  for (let char of text) {
    if (char === '"') {
      if (outsideQuote && char === prevChar) row[colIndex] += char;
      outsideQuote = !outsideQuote;
    } else if (char === ',' && outsideQuote) {
      colIndex += 1;
      char = '';
      row[colIndex] = '';
    } else if (char === '\n' && outsideQuote) {
      if (prevChar === '\r') {
        row[colIndex] = row[colIndex].slice(0, -1);
      }
      char = '';
      row = [''];
      rowIndex += 1;
      colIndex = 0;
      rows[rowIndex] = row;
    } else {
      row[colIndex] += char;
    }
    prevChar = char;
  }
  // If last char is a newline we'll have an extra (empty) row we should remove
  if (rows[rows.length - 1].length === 1 && rows[rows.length - 1][0] === '')
    rows.pop();

  return asObjects ? convertToObjects(rows) : rows;
}

export const downloadFile = async (source, defaultFilename = 'file') => {
  let blob;
  let filename = defaultFilename;

  if (source instanceof Response) {
    blob = await source.blob();
    filename = source.headers.has('Content-Disposition')
      ? source.headers
          .get('Content-Disposition')
          .split('filename=')[1]
          .split(';')[0]
          .replace(/['"]/g, '')
      : defaultFilename;
  } else if (source instanceof Blob) {
    blob = source;
  } else if (typeof source === 'string') {
    blob = new Blob([source]);
  } else {
    throw Error(`Unsupported source type: ${typeof source}`);
  }

  // Replace problematic chars in filename with underscores
  filename = filename.replaceAll(/[^0-9a-zA-Z-._]/g, '_');

  const blobUrl = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = blobUrl;
  a.download = filename;
  document.body.appendChild(a); // append element to the dom (required in firefox)
  a.click();
  a.remove(); // afterwards remove the element
};

export const sleep = ms =>
  new Promise(resolve => {
    setTimeout(resolve, ms);
  });
